/**
 * This script contains helper functions to iteract with One Alerts interface.
 */
import type { AlertType } from '@sydle/sydle-one-components';
import { AlertsHelpers } from '@sydle/sydle-one-components';

export function pushAlert(alert: { text: string; type: AlertType }): boolean {
  AlertsHelpers.add([alert]);
  return true;
}
